import * as React from 'react';
import { useContext, useEffect } from 'react';
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from 'react-router-dom';

import Layout from './layout/Layout';
import Login from './login/Login';
import { AuthContext } from './store/authContext';
import UserList from './users/UserList';
import ProductList from './products/ProductList';
import DashboardPage from './dashboard/DashboardPage';
import RootStorageComponent from './storages/RootStorageComponent';
import ApplicationLinksList from "./ApplicationLinks/ApplicationLinksList";

const VPTApp: React.FC = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const history = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    if (isLoggedIn === false && pathname !== '/login') {
      history('/login');
    }
  }, [isLoggedIn, history, pathname]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/sites" element={<RootStorageComponent />} />
        <Route path="/products" element={<ProductList />} />
        <Route path="/applicationlinks" element={<ApplicationLinksList />} />
        <Route path="*" element={<Navigate to="/users" replace />} />
      </Routes>
    </Layout>
  );
};

export default VPTApp;
